import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const services = [
  {
    details:
      "Demonstrate a clear problem statement and a locally relevant solution.",
  },
  {
    details:
      "Align with our principles of sustainability, scalability, and inclusivity.",
  },
  {
    details:
      "Show measurable impact goals, such as improving governance, reducing environmental vulnerabilities, or increasing economic opportunities.",
  },
  {
    details:
      "Prioritize equity by addressing the needs of underserved groups, including women, youth, and people with disabilities.",
  },
];

const Invest = () => {
  return (
    <Box margin={{ xs: "25% 0% 15% 0%", sm: "2% 0% 10% 0%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        // alignItems={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingRight={{ xs: "0%", sm: "4%" }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "4%" }}
            textAlign={"left"}
            color={"#39484E"}
          >
            {" "}
            What We Will Invest In
          </Typography>
          <Typography
            fontSize={"1.1rem"}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#000"}
          >
            {" "}
            AIR Fund targets projects that address Africa’s most critical
            challenges and untapped opportunities, focusing on innovative
            solutions that are sustainable, inclusive, and scalable. By
            investing in high-impact initiatives, the Fund aims to empower
            communities to adapt to changing environments, build resilience, and
            drive systemic change. AIR Fund emphasizes African-led solutions,
            ensuring that local ingenuity and expertise are at the forefront of
            transformative progress.
          </Typography>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          color={"#D8C4B6"}
          width={4}
        />
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingLeft={{ xs: "0%", sm: "4%" }}
          paddingTop={{ xs: "25%", sm: "0%" }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#39484E"}
          >
            {" "}
            What will we fund
          </Typography>
          <Typography
            variant="h6"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#4f4f4f"}
          >
            {" "}
            AIR Fund will support projects that:
          </Typography>
          {services.map((data, index) => (
            <Box display={"flex"} alignItems={"flex-start"} key={index}>
              <Typography
                variant="h4"
                fontWeight={700}
                paddingRight={"4%"}
                textAlign={"left"}
                color={"#948979"}
              >
                {" "}
                &#8226;
              </Typography>

              <Typography
                variant="body1"
                fontWeight={400}
                paddingBottom={{ xs: "4%", sm: "2%" }}
                textAlign={"left"}
                color={"#000"}
              >
                {data.details}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Invest;
